const routes = {
  root: '/',
  signin: '/signin',
  merchants: '/merchants',
  merchant: (id: string) => `/merchants/${id}`,
  marketplaces: '/marketplaces',
  scans: (id: string) => `/scans/${id}`,
  marketplaceDecisions: (id: string) => `/marketplaces/${id}/decisions`,
  import: '/import',
  management: '/management',
  references: '/management/references',
  tags: '/management/tags',
};

export default routes;
